import { useEffect, useState } from "react";
import { t } from "i18next";
import { Input } from "@material-tailwind/react";
import DynamicListSelect from "../../../components/data/dynamic-list/DynamicListSelect";
import { toReleaseYear } from "../../../components/data/machines/MachineForm";

interface MachinesFilterFormProps {
  data?: Partial<EasyTech.MachinesFilterType>;
  onChange: (name: string, value: any) => void;
  onSubmit: () => void;
  submitted?: boolean;
}

const MachinesFilterForm = (props: MachinesFilterFormProps) => {
  const [formData, setFormData] = useState<Partial<EasyTech.MachinesFilterType>>({
    ref: "",
    serialNumber: "",
    releaseYear: "",
    type: undefined,
    brand: undefined
  });

  useEffect(() => {
    if (props.data) {
      setFormData(props.data);
    } else {
      setFormData({
        ref: "",
        serialNumber: "",
        releaseYear: "",
        type: undefined,
        brand: undefined
      });
    }
  }, [props.data]);

  const handleChange = (value: any, name: string) => {
    const tmp = structuredClone(formData);
    tmp[name as keyof Partial<EasyTech.MachinesFilterType>] = value;
    props.onChange(name, value);
    setFormData(tmp);
  };

  const submit = (e: any) => {
    e.preventDefault();
    props.onSubmit();
  };

  return (
    <form onSubmit={submit} className="grid gap-4 p-2" key={"edit-machines-filter"}>
      <div className="grid grid-cols-1 gap-4">
        <div className="field">
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("machine:form:fields:ref:label")}</label>
          <Input
            value={formData.ref || ""}
            onChange={(e) => handleChange(e.target.value, "ref")}
            className="w-full"
            size="md"
            placeholder={t("common:ref:placeholder")}
          />
        </div>
        
        <div className="field">
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("machine:form:fields:serialNumber:label")}</label>
          <Input
            value={formData.serialNumber || ""}
            onChange={(e) => handleChange(e.target.value, "serialNumber")}
            className="w-full"
            size="md"
            placeholder={t("machine:form:fields:serialNumber:placeholder")}
          />
        </div>
        
        <div className="field">
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("machine:form:fields:releaseYear:label")}</label>
          <Input
            type="number"
            inputMode="numeric"
            min={0}
            max={9999}
            step={1}
            value={formData.releaseYear || ""}
            onChange={(e) => handleChange(toReleaseYear(e.target.value), "releaseYear")}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", ".", ","].includes(e.key)) e.preventDefault();
            }}
            className="w-full"
            size="md"
            placeholder={t("machine:form:fields:releaseYear:placeholder")}
          />
        </div>
        
        <div className="field">
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("machine:form:fields:type:label")}</label>
          <DynamicListSelect
            data={formData.type}
            ressource="ma-type"
            onChange={(value) => handleChange(value, "type")}
          />
        </div>
        
        <div className="field">
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("machine:form:fields:brand:label")}</label>
          <DynamicListSelect
            data={formData.brand}
            ressource="ma-brand"
            onChange={(value) => handleChange(value, "brand")}
          />
        </div>
      </div>
    </form>
  );
};

export default MachinesFilterForm; 